<template>
  <div class="mall-order-products">
    <MallSubTitle :label="'주문상품 ' + items.length + '개'" />
    <MallCard>
      <div v-for="item in items" :key="item.id" class="mall-order-products__item">
        <img v-if="item.image" class="mall-order-products__thumb" :src="item.image" :alt="item.name" />
        <div v-else class="mall-order-products__thumb mall-order-products__thumb--empty"></div>
        <div class="mall-order-products__text">
          <span class="mall-order-products__name">{{ item.name }}</span>
          <span>{{ formatNumber(item.price) }}·{{ item.quantity }}개</span>
        </div>
      </div>
      <div class="mall-order-products__divider"></div>
      <div class="mall-order-products__total">
        <span class="mall-order-products__total-label">주문 금액</span>
        <span>{{ formatNumber(orderPrice) }}원</span>
      </div>
    </MallCard>
  </div>
</template>

<script>
import convert from '@/utilities/convert.js'
import MallCard from '@/components/new/atoms/MallCard.vue'
import MallSubTitle from '@/components/new/atoms/MallSubTitle.vue'

export default {
  name: 'MallOrderProducts',
  components: {
    MallCard,
    MallSubTitle,
  },
  props: {
    // [{ id, name, image, price(개당), quantity }]
    items: {
      type: Array,
      required: true,
    },
    // 주문 금액 (서버 계산값, 없으면 상품 금액 합계)
    totalPrice: {
      type: Number,
      default: null,
    },
  },
  computed: {
    orderPrice() {
      if (this.totalPrice !== null) return this.totalPrice
      return this.items.reduce((sum, item) => sum + item.price * item.quantity, 0)
    },
  },
  methods: {
    formatNumber(value) {
      return convert.setComma(value)
    },
  },
}
</script>

<style scoped>
.mall-order-products {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mall-order-products__item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.mall-order-products__thumb {
  display: block;
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
}

.mall-order-products__thumb--empty {
  background: #F2F4F6;
}

.mall-order-products__text {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
  color: #4E5968;
  font-family: Pretendard;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
}

.mall-order-products__name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.mall-order-products__divider {
  height: 1px;
  background: #F2F4F6;
}

.mall-order-products__total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--color-text-main);
  font-family: Pretendard;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
  white-space: nowrap;
}

.mall-order-products__total-label {
  color: #8B95A1;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/MallOrderProducts.vue